<template>
  <div class="trial-apply-page">
    <main class="trial-apply">
      <div class="trial-apply-layout">
        <trial-banner class="trial-apply-banner" />
        <header class="trial-apply-header">
          <p class="trial-eyebrow">DCMP 企业试用</p>
          <h1 id="trial-page-title">让电池数字护照，<br class="trial-title-break">从试用开始。</h1>
          <p class="trial-description">填写企业信息，提交您的试用需求。<br>审核通过后，通过企业邮箱激活账号。</p>
        </header>
        <div class="trial-process-panel">
          <ol class="trial-process" aria-label="试用申请流程">
            <li><span class="trial-step" aria-hidden="true">1</span><div><strong>填写申请</strong><p>保留申请编号，便于后续查询</p></div></li>
            <li><span class="trial-step" aria-hidden="true">2</span><div><strong>运营审核</strong><p>我们将核实您的企业试用需求</p></div></li>
            <li><span class="trial-step" aria-hidden="true">3</span><div><strong>邮件激活</strong><p>按审核邮件指引，开启试用</p></div></li>
          </ol>
        </div>
        <form-nav class="trial-apply-form" standalone />
      </div>
    </main>
    <footer class="trial-apply-footer">
      <span>{{ $portalText('navigation', 'siteName') }}</span>
      <p>{{ $portalText('footer', 't011') }} <a :href="recordLink" target="_blank" rel="noopener noreferrer">{{ $portalText('footer', 't012') }}</a></p>
    </footer>
  </div>
</template>

<script>
import TrialBanner from './TrialBanner.vue';
import { safePortalLink } from '@/portal/content.mjs';
export default {
  name: 'TrialApply',
  components: { TrialBanner },
  metaInfo: {
    title: '申请 DCMP 企业试用 | 电池数字护照',
    meta: [{ name: 'description', content: '申请 DCMP 企业试用，填写企业信息和试用需求，审核通过后通过企业邮箱激活，开启电池数字护照体验。' }],
    link: [{ rel: 'canonical', href: 'https://www.chdpp.com/trial/' }],
  },
  computed: { recordLink() { return safePortalLink(this.$portalText('footer', 'l004')); } },
};
</script>

<style scoped>
.trial-apply-page { display: flex; flex: 1 0 auto; flex-direction: column; --trial-accent: #006b80; background: #f5f5f7; color: #1d1d1f; font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif; font-size: 16px; line-height: 1.6; }
.trial-apply-page * { box-sizing: border-box; font-family: inherit; font-size: inherit; flex-shrink: 1; }
.trial-apply { --trial-top-space: clamp(40px, 5vw, 88px); --trial-card-overlap: 72px; position: relative; isolation: isolate; overflow: hidden; padding: var(--trial-top-space) 32px 64px; min-height: 0; background-color: #eff6fd; background-image: radial-gradient(circle at 1px 1px, rgba(85, 144, 190, .1) .7px, transparent .8px); background-size: 20px 20px; }
.trial-apply-page > .trial-apply { flex: 1 0 auto; }
.trial-apply-page > .trial-apply-footer { flex: 0 0 auto; }
.trial-apply-layout { position: relative; display: grid; grid-template-columns: minmax(280px, .8fr) minmax(0, 1.2fr); grid-template-rows: auto auto; align-items: start; column-gap: clamp(48px, 6vw, 112px); max-width: 1200px; margin: 0 auto; }
/* The first grid row defines the Banner; content height, not a guessed viewport value, sets its edge. */
.trial-apply-layout > .trial-apply-banner { grid-area: 1 / 1 / 2 / -1; top: calc(0px - var(--trial-top-space)); bottom: 0; left: calc((100% - 100vw) / 2); right: calc((100% - 100vw) / 2); }
.trial-apply-header { grid-area: 1 / 1 / 2 / 2; padding: 28px 0 96px; min-width: 0; color: #fff; }
.trial-apply-form { grid-area: 2 / 2 / 3 / 3; position: relative; z-index: 1; margin-top: calc(0px - var(--trial-card-overlap)); }
.trial-apply-form ::v-deep .trial-card { border-color: #e1eaf3; box-shadow: 0 16px 42px rgba(38, 78, 113, .08); }
.trial-eyebrow { margin: 0 0 20px; color: #fff; font-size: 14px; font-weight: 600; letter-spacing: .08em; }
.trial-apply-header h1 { margin: 0; color: #fff; font-size: clamp(34px, 3vw, 44px); font-weight: 600; letter-spacing: -.025em; line-height: 1.28; }
.trial-description { margin: 24px 0 0; color: #fff; font-size: 17px; line-height: 1.75; }
.trial-process-panel { grid-area: 2 / 1 / 3 / 2; min-width: 0; padding-top: 36px; color: #24394c; }
.trial-process { margin: 0; padding: 0; list-style: none; display: grid; gap: 28px; }
.trial-process li { display: flex; align-items: flex-start; gap: 16px; position: relative; }
.trial-process li:not(:last-child)::after { content: ''; position: absolute; left: 15px; top: 37px; width: 1px; height: 32px; background: #d4e1ec; }
.trial-step { flex: 0 0 32px; display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border: 1px solid #d6e2e5; border-radius: 50%; background: #fff; color: var(--trial-accent); font-size: 14px; font-weight: 600; }
.trial-process strong { display: block; font-size: 16px; line-height: 1.5; font-weight: 600; }
.trial-process p { margin: 5px 0 0; color: #607588; font-size: 14px; line-height: 1.65; }
.trial-apply-footer a:focus-visible { outline: 3px solid #78b5c3; outline-offset: 5px; border-radius: 3px; }
.trial-apply-footer { display: flex; justify-content: space-between; gap: 16px 32px; align-items: center; max-width: 1264px; margin: 0 auto; padding: 24px 32px 30px; color: #6e6e73; font-size: 12px; line-height: 1.8; }
.trial-apply-footer p { margin: 0; text-align: right; }
.trial-apply-footer a { color: inherit; text-decoration: none; }
.trial-apply-footer a:hover { color: var(--trial-accent); text-decoration: underline; }
@media (max-width: 1000px) {
  .trial-apply { --trial-top-space: 40px; --trial-card-overlap: 28px; padding: var(--trial-top-space) 24px 48px; }
  .trial-apply-layout { max-width: 680px; grid-template-columns: minmax(0, 1fr); grid-template-rows: auto auto auto; }
  .trial-apply-layout > .trial-apply-banner { grid-area: 1 / 1 / 3 / -1; }
  .trial-apply-header { grid-area: 1 / 1 / 2 / 2; padding: 0 4px; }
  .trial-process-panel { grid-area: 2 / 1 / 3 / 2; padding: 24px 4px 52px; color: #fff; }
  .trial-apply-form { grid-area: 3 / 1 / 4 / 2; }
  .trial-eyebrow { margin-bottom: 12px; }
  .trial-apply-header h1 { font-size: 36px; }
  .trial-title-break { display: none; }
  .trial-description { margin-top: 16px; font-size: 16px; }
  .trial-process { grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
  .trial-process li { gap: 9px; align-items: center; }
  .trial-process li::after, .trial-process p { display: none; }
  .trial-process strong { font-size: 14px; white-space: nowrap; }
  .trial-step { width: 26px; height: 26px; flex-basis: 26px; font-size: 12px; }
}
@media (max-width: 600px) {
  .trial-apply { --trial-top-space: 28px; padding: var(--trial-top-space) 16px 32px; }
  .trial-apply-header h1 { font-size: clamp(27px, 7.5vw, 34px); }
  .trial-title-break { display: initial; }
  .trial-description { font-size: 15px; line-height: 1.8; }
  .trial-description br { display: none; }
  .trial-process { gap: 8px; }
  .trial-process li { gap: 7px; }
  .trial-process strong { font-size: 13px; }
  .trial-step { width: 24px; height: 24px; flex-basis: 24px; }
  .trial-apply-footer { display: block; text-align: center; padding: 16px 24px 24px; }
  .trial-apply-footer p { margin-top: 6px; text-align: center; overflow-wrap: anywhere; }
}
@media (prefers-reduced-motion: reduce) { .trial-apply-page * { scroll-behavior: auto; transition: none; } }

/* Preview: original form styling; only the surrounding desktop space moves it up. */
@media (min-width: 1001px) {
  .trial-apply { --trial-top-space: clamp(32px, 4vw, 64px); }
  .trial-apply-header { padding-bottom: 64px; }
  .trial-apply-form { margin-top: calc(0px - var(--trial-card-overlap) - 80px); }
}
</style>
